// extracted by mini-css-extract-plugin
export default {"invitedGroupItemContainer":"style_invitedGroupItemContainer__McQ34","data":"style_data__BJiCa"};